import { LEAGUE_PITCHES } from "./pitches.generated";

export function curatedPitch(leagueName: string): string | null {
  return LEAGUE_PITCHES[leagueName] ?? null;
}
